import React, { useEffect, useState, Fragment } from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Flame, Zap } from 'lucide-react';
export function PurchaseSection() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 2,
    minutes: 47,
    seconds: 33
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let {
          hours,
          minutes,
          seconds
        } = prev;
        seconds -= 1;
        if (seconds < 0) {
          seconds = 59;
          minutes -= 1;
        }
        if (minutes < 0) {
          minutes = 59;
          hours -= 1;
        }
        if (hours < 0) {
          hours = 0;
          minutes = 0;
          seconds = 0;
        }
        return {
          hours,
          minutes,
          seconds
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const pad = (n: number) => n.toString().padStart(2, '0');
  return <section id="comprar" className="py-16 px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto scroll-mt-20" data-id="element-139">
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} className="relative bg-brand-card rounded-[3rem] shadow-2xl border-2 border-brand-cta/30 overflow-hidden" data-id="element-140">
        {/* Urgency Banner */}
        <div className="bg-brand-cta text-white py-3 px-6 text-center" data-id="element-141">
          <div className="flex items-center justify-center gap-2 text-sm sm:text-base font-bold uppercase tracking-wider" data-id="element-142">
            <span data-id="element-143">🔥 OFERTA SOLO POR HOY — 50% DE DESCUENTO 🔥</span>
          </div>
        </div>

        {/* Countdown Timer */}
        <div className="bg-brand-deep-green py-5 px-6" data-id="element-144">
          <p className="text-brand-card/80 text-sm font-medium text-center mb-3 uppercase tracking-wider" data-id="element-145">
            Esta oferta termina en
          </p>
          <div className="flex items-center justify-center gap-3 sm:gap-4" data-id="element-146">
            {[{
            value: pad(timeLeft.hours),
            label: 'Horas'
          }, {
            value: pad(timeLeft.minutes),
            label: 'Min'
          }, {
            value: pad(timeLeft.seconds),
            label: 'Seg'
          }].map((unit, i) => <Fragment key={i} data-id="element-147">
                {i > 0 && <span className="text-3xl sm:text-4xl font-bold text-brand-card/60" data-id="element-148">
                    :
                  </span>}
                <div className="flex flex-col items-center" data-id="element-149">
                  <motion.span key={unit.value} initial={{
                scale: 1.1,
                opacity: 0.7
              }} animate={{
                scale: 1,
                opacity: 1
              }} transition={{
                duration: 0.2
              }} className="bg-brand-card/10 backdrop-blur-sm border border-brand-card/20 rounded-xl w-16 sm:w-20 h-16 sm:h-20 flex items-center justify-center text-3xl sm:text-4xl font-bold text-white font-mono" data-id="element-150">
                    {unit.value}
                  </motion.span>
                  <span className="text-brand-card/60 text-xs mt-1 uppercase tracking-wider" data-id="element-151">
                    {unit.label}
                  </span>
                </div>
              </Fragment>)}
          </div>
        </div>

        {/* Content */}
        <div className="p-8 sm:p-12 lg:p-16 flex flex-col items-center text-center" data-id="element-152">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl text-brand-text mb-4 leading-tight" data-id="element-153">
            Mega Kit de Tricotín Creativo
          </h2>

          <ul className="space-y-3 mb-10 text-left inline-block" data-id="element-154">
            {['Material digital listo para descargar', 'Ideal para principiantes'].map((benefit, i) => <motion.li key={i} initial={{
            opacity: 0,
            x: -10
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1 * i
          }} className="flex items-center gap-3" data-id="element-155">
                <CheckCircle2 className="text-brand-accent shrink-0" size={22} data-id="element-156" />
                <span className="text-brand-text font-medium text-base sm:text-lg" data-id="element-157">
                  {benefit}
                </span>
              </motion.li>)}
          </ul>

          {/* Pricing */}
          <div className="bg-brand-alt-bg/60 rounded-2xl p-6 sm:p-8 mb-8 border border-brand-accent/20 w-full max-w-md" data-id="element-158">
            <div className="flex flex-col items-center gap-2" data-id="element-159">
              <span className="text-xl text-brand-text/40 line-through font-serif" data-id="element-160">
                $39.990 ARS
              </span>
              <div className="flex items-center gap-2" data-id="element-161">
                <span className="text-sm text-brand-cta font-bold uppercase tracking-wider" data-id="element-162">
                  Precio especial hoy
                </span>
              </div>
              <span className="text-5xl sm:text-6xl text-brand-text font-serif font-bold leading-none" data-id="element-163">
                $19.990 <span className="text-2xl" data-id="element-164">ARS</span>
              </span>
              <span className="text-sm text-brand-deep-green font-semibold mt-1" data-id="element-165">
                ¡Ahorrás $20.000!
              </span>
            </div>
          </div>

          {/* CTA Button */}
          <motion.a href="https://pago.atlasdigitalhub.com/cart/42668753846370:1" whileHover={{
          scale: 1.03
        }} whileTap={{
          scale: 0.97
        }} className="inline-flex items-center justify-center w-full max-w-md px-10 py-6 rounded-full bg-brand-cta text-white text-xl font-bold uppercase tracking-wider shadow-xl hover:bg-[#c26a50] transition-colors duration-300 relative overflow-hidden" data-id="element-166">
            <motion.div className="absolute inset-0 bg-white/20" animate={{
            x: ['-100%', '200%']
          }} transition={{
            duration: 2,
            repeat: Infinity,
            repeatDelay: 3,
            ease: 'easeInOut'
          }} data-id="element-167" />
            <span className="relative z-10 text-[14px]" data-id="element-168">
              QUIERO EL MEGA KIT
            </span>
          </motion.a>

          <p className="text-center text-xs text-brand-text/50 mt-6" data-id="element-169">
            Producto digital. Accedés al material de forma inmediata después de
            tu compra.
          </p>
        </div>
      </motion.div>
    </section>;
}